import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

const shelfItemShape = ImmutablePropTypes.contains({
  id: PropTypes.number.isRequired,
  metadataId: PropTypes.string.isRequired,
  shelf: PropTypes.string.isRequired,
  privateItem: PropTypes.bool.isRequired,
  dateAdded: PropTypes.string.isRequired,
  authors: ImmutablePropTypes.listOf(PropTypes.string),
  title: PropTypes.string,
  rating: PropTypes.number
});

export default shelfItemShape;
